import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input} from '@angular/core';

import {
  INotification,
  INotificationStage,
  INotificationType,
  NotificationType,
  NotificationTypeEnum,
  StageNotificationEnum
} from './../../../models/notification';
import { SnackbarType } from './../../../models/snackbar-type.enum';
import { SnackbarService } from './../../../services/snackbar.service';
import { NotificationService } from 'src/app/services/api/notification.service';
import { IContractByNumberFormData } from 'src/app/models/contract';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';

type notificationStatus = 'status' | 'contract';
enum NotificationEnum {
  Status = 'status',
  Contract = 'contract'
}

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss']
})
export class NotificationModalComponent implements OnInit {
  @Input() notifications: INotificationType[] = [];

  @Output() closeNotificationsEvent = new EventEmitter<any>();
  @Output() changeBadgeNumberEvent = new EventEmitter<number>();

  NotificationEnum = NotificationEnum;
  mode: notificationStatus = NotificationEnum.Status;
  NotificationType = NotificationTypeEnum;
  StageNotificationEnum = StageNotificationEnum;
  Number = Number;

  contractNotifications: { [key: string]: INotification[] } = {
    CancelContract: [],
    CancelCompany: []
  };
  statusNotification: { [key: string]: INotificationStage } = {
    [NotificationTypeEnum.CancelCompany]: {
      label: 'Não Registrados',
      badgeNumber: 0
    },
    [NotificationTypeEnum.CancelContract]: {
      label: 'Cancelados',
      badgeNumber: 0
    }
  };
  currentContracts: INotification[] = [];
  showLoader: boolean = false;

  constructor(
    private _dialogService: ApiDialogService,
    private _notificationService: NotificationService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.handleStorageNotification();
  }

  handleStorageNotification(): void {
    let stageContract = this._notificationService.getStorageStatus(
      NotificationTypeEnum.CancelContract
    ) as INotificationStage;
    let stageCompany = this._notificationService.getStorageStatus(
      NotificationTypeEnum.CancelCompany
    ) as INotificationStage;
    let notification = this._notificationService.getStorageStatus(
      NotificationTypeEnum.Notification
    ) as INotificationStage;
    let checkOpen: boolean = false;

    if (stageContract && stageContract.stage === StageNotificationEnum.Open) {
      checkOpen = true;
      this.contractNotifications[NotificationTypeEnum.CancelContract] =
        this._notificationService.getStorageContracts(
          NotificationTypeEnum.CancelContractList
        ) ?? [];
    } else if (stageContract) {
      this.statusNotification[NotificationTypeEnum.CancelContract].badgeNumber =
        stageContract.badgeNumber;
    }

    if (stageCompany && stageCompany.stage === StageNotificationEnum.Open) {
      checkOpen = true;
      this.contractNotifications[NotificationTypeEnum.CancelCompany] =
        this._notificationService.getStorageContracts(
          NotificationTypeEnum.CancelCompanyList
        ) ?? [];
    } else if (stageCompany) {
      this.statusNotification[NotificationTypeEnum.CancelCompany].badgeNumber =
        stageCompany.badgeNumber;
    }

    if (!notification || notification.stage === StageNotificationEnum.Close) {
      this._notificationService.removeStorageContracts(
        NotificationTypeEnum.CancelCompanyList
      );
      this._notificationService.removeStorageContracts(
        NotificationTypeEnum.CancelContractList
      );
    }

    if (!checkOpen) {
      this.showLoader = true;
      this.getCountNotification();
    }

    this.checkStatusBadgeNumber();
  }

  getCountNotification(realodMsg: boolean = false): void {
    this._notificationService.getCountNotification().subscribe({
      next: (response) => {
        this.notifications = response;
        this.handleStatusNotification(realodMsg);
      }
    });
  }

  handleStatusNotification(realodMsg: boolean): void {
    const cancelCompany = this.notifications.find(
      (not) => not.Notification === NotificationTypeEnum.CancelCompany
    ) as INotificationType;
    const cancelContract = this.notifications.find(
      (not) => not.Notification === NotificationTypeEnum.CancelContract
    ) as INotificationType;

    this.setStatusAndBadgeNumberStorage(cancelCompany, cancelContract);
    this.builderStatusNotification(cancelCompany, cancelContract);

    if (cancelCompany.Count === 0 && cancelContract.Count === 0 && realodMsg)
      this._snackbarService.openSnackBar(
        'Não há Notificações novas!',
        SnackbarType.Warn,
        3000
      );
  }

  setStatusAndBadgeNumberStorage(
    cancelCompany: INotificationType,
    cancelContract: INotificationType
  ): void {
    if (cancelCompany.Count > 0) {
      this._notificationService.setStorageStatus(
        NotificationTypeEnum.CancelCompany,
        'close',
        cancelCompany.Count
      );
      this._notificationService.removeStorageContracts(
        NotificationTypeEnum.CancelCompanyList
      );
    }

    if (cancelContract.Count > 0) {
      this._notificationService.setStorageStatus(
        NotificationTypeEnum.CancelContract,
        'close',
        cancelContract.Count
      );
      this._notificationService.removeStorageContracts(
        NotificationTypeEnum.CancelContractList
      );
    }

    this._notificationService.setStorageStatus(
      NotificationTypeEnum.Notification
    );
  }

  builderStatusNotification(
    cancelCompany: INotificationType,
    cancelContract: INotificationType
  ): void {
    this.statusNotification[NotificationTypeEnum.CancelCompany].badgeNumber =
      cancelCompany.Count;
    this.statusNotification[NotificationTypeEnum.CancelContract].badgeNumber =
      cancelContract.Count;

    this.checkStatusBadgeNumber();
    this.showLoader = false;
  }

  checkAndReturnBadgeNumber(
    statusType: NotificationType,
    notification: INotificationType
  ): number {
    let badgeNumber: number = 0;
    let sessionStatus: INotificationStage | null =
      this._notificationService.getStorageStatus(statusType);

    if (!sessionStatus) {
      badgeNumber = notification.Count;
    }

    return badgeNumber;
  }

  handlerContracts(statusName: NotificationType): void {
    this.mode = NotificationEnum.Contract;

    if (Number(this.statusNotification[statusName].badgeNumber) > 0) {
      this._notificationService.setStorageStatus(statusName);
      this.getContractNotifications(statusName);
    } else {
      this.currentContracts = [...this.contractNotifications[statusName]];
    }
  }

  getContractNotifications(statusName: NotificationType): void {
    this.showLoader = true;
    this.currentContracts = [];

    this._notificationService.getNotificationsByType(statusName).subscribe({
      next: (response) => {
        this.currentContracts = [...response];
        this.contractNotifications[statusName] = [...response];
        if (response.length > 0) {
          let statusList: NotificationType =
            statusName === NotificationTypeEnum.CancelCompany
              ? NotificationTypeEnum.CancelCompanyList
              : NotificationTypeEnum.CancelContractList;
          this._notificationService.setStorageContracts(
            statusList,
            this.currentContracts
          );
        }
        this.setStatusBadgeNumber(statusName);
        this.showLoader = false;
      }
    });
  }

  setStatusBadgeNumber(statusName: NotificationType): void {
    this.statusNotification[statusName].badgeNumber = 0;
    this.checkStatusBadgeNumber();
  }

  checkStatusBadgeNumber(): void {
    let badgeNumberContract = Number(
      this.statusNotification[NotificationTypeEnum.CancelContract].badgeNumber
    );
    let badgeNumberCompany = Number(
      this.statusNotification[NotificationTypeEnum.CancelCompany].badgeNumber
    );

    this.changeBadgeNumberEvent.emit(badgeNumberCompany + badgeNumberContract);
  }

  closeNotifications(): void {
    this.closeNotificationsEvent.emit();
  }

  handlerContractDetails(contractNumber: number | string): void {
    const data: IContractByNumberFormData = {
      Number: contractNumber
    };

    console.log(3, data);

    this._dialogService.openContractDetailsDialog(data).then((response) => {});
  }

  reloadNotifications(): void {
    this.showLoader = true;
    this.getCountNotification(true);
  }
}
